<template>
  <div class="chart-card primaryFont">
    <h2 class="ml-3 my-0">{{ title }}</h2>
    <apexchart type="bar" height="610" :options="chartOptions" :series="series" v-if="!loading" />
    <div
      v-else
      class="w-full flex justify-content-center align-items-center"
      style="min-height: 610px"
    >
      <p class="loading">Cargando...</p>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  title: { type: String, required: true },
  series: { type: Array, required: true },
  categories: { type: Array, required: true },
  titleSize: {
    type: String,
    default: "32px",
  },
  loading: { type: Boolean, required: true },
});

const chartOptions = computed(() => {
  const categories = props.categories || []; // fallback seguro

  return {
    chart: {
      type: "bar",
      stacked: true,
      stackType: "normal",
      toolbar: { show: false },
      fontFamily: "IBM Plex Sans, sans-serif",
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "28px",
        distributed: false,
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#ffffff"],
    },
    grid: {
      padding: {
        left: 5,
        right: 0,
        top: 0,
        bottom: 0,
      },
      row: {
        colors: ["#fff"],
        opacity: 1,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontFamily: "IBM Plex Sans, sans-serif",
      },
    },
    xaxis: {
      categories,
      labels: {
        show: false,
        trim: false,
      },
    },
    yaxis: {
      labels: {
        align: "left",
        minWidth: 60,
        trim: false,
        style: {
          fontFamily: "IBM Plex Sans, sans-serif",
          fontSize: "13px",
          fontWeight: 800,
          cssClass: "apexcharts-yaxis-label no-ellipsis",
        },
      },
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      position: "top",
      horizontalAlign: "left",
      fontFamily: "IBM Plex Sans, sans-serif",
    },
    colors: ["#3AC0EB", "#2494FD", "#546BAA"],
  };
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;600&display=swap");

.chart-card {
  min-width: 700px;
  min-height: 660px;
  width: 100%;
  max-width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px #00000040;
  padding: 5px 24px;
}

.loading {
  color: #0b5195;
  font-weight: 600;
  font-size: 20px;
}

>>> .apexcharts-yaxis-label .no-ellipsis {
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: normal !important;
}
</style>
